import { Ref } from 'react';

import styles from './ActionableWarningButton.module.scss';

interface ActionableWarningButtonProps {
  readonly ariaLabel: string;
  readonly onClick: () => void;
  readonly ref?: Ref<HTMLButtonElement>;
}

/**
 * A blinking "dot" button, used to indicate there are inline edits available
 * in certain parts of the Content
 */
export function ActionableWarningButton({ ariaLabel, onClick, ref }: ActionableWarningButtonProps) {
  return (
    <button ref={ref} type="button" className={styles.dot} aria-label={ariaLabel} onClick={onClick}>
      <span className={styles.dotInner} />
    </button>
  );
}
